app.component("patientDashboard", {
	templateUrl: "app/src/js/components/patientDashboard/patientDashboard.html",
	controller: "patientDashboardController",
});

app.controller("patientDashboardController", [
	"$scope", "$location", "CurrentPatient",
	"Session", "$timeout", "$q", "PatientAPI", "$modal", "ReferralsAPI", "CurrentReferral",
	"$state", "OperationNote", "OperationAPI", "$filter", "ContactAPI", "$window",
	"PatientAiConversationAPI",
	"InjectionNoteAPI", "UploadFileAPI", "ProgressNoteAPI", "ElevenLabsAPI", "DiagnosisAPI",
	"ShareData", "countryConfig", "$mdDialog", "NEXT_OF_KIN_1070",
	"InfoPopoverHover", "PatientDuplicate", "toast",
	"PatientRecordLiveUpdateService", "ChunkedRecordingService", "PatientImportReview",
	function (
		$scope, $location, CurrentPatient,
		Session, $timeout, $q, PatientAPI, $modal, ReferralsAPI, CurrentReferral,
		$state, OperationNote, OperationAPI, $filter, ContactAPI, $window,
		PatientAiConversationAPI,
		InjectionNoteAPI, UploadFileAPI, ProgressNoteAPI, ElevenLabsAPI, DiagnosisAPI,
		ShareData, countryConfig, $mdDialog, NEXT_OF_KIN_1070,
		InfoPopoverHover, PatientDuplicate, toast,
		PatientRecordLiveUpdateService, ChunkedRecordingService, PatientImportReview
	) {
		// ==========================================
		// VARIABLE INITIALIZATION & STATE
		// ==========================================
		this.CP = CurrentPatient;

		// Aliases
		$scope.Session = Session;
		$scope.CP = CurrentPatient;
		$scope.PA = PatientAPI;
		$scope.RA = ReferralsAPI;
		$scope.CR = CurrentReferral;
		$scope.ContactAPI = ContactAPI;
		$scope.ShareData = ShareData;
		$scope.ElevenLabsAPI = ElevenLabsAPI;
		$scope.fileAPI = UploadFileAPI;
		$scope.PNAPI = ProgressNoteAPI;
		$scope.DiagnosisAPI = DiagnosisAPI;
		$scope.PatientAiConversationAPI = PatientAiConversationAPI;

		// Constants & Configs
		$scope.countryConfig = countryConfig;

		// UI State Flags
		$scope.CALENDAR_ENABLE = false;
		$scope.isNHIFeatureEnabled = false;
		$scope.showTimeline = true;
		$scope.status = { open: false };
		$scope.popoverOpened1 = false;
		$scope.tooltipHide = false;
		$scope.showWorkupButton = false;
		$scope.showOperationNoteButton = false;
		$scope.showCommentsOnly = false;
		$scope.showPatientEdit = true;
		$scope.hideSaveButton = false;
		$scope.showEditButton = false;
		// Set when a registration POST fails, so the reason stays visible on the form
		// while the user corrects the details. Cleared on the next save or on cancel.
		$scope.registrationError = null;
		// Double-submit guards: one per in-flight save so the corresponding button
		// stays disabled (and re-entrant clicks are ignored) until it resolves.
		$scope.isSubmitting = false;
		$scope.isSubmittingComment = false;
		$scope.isSubmittingDiagnosis = false;
		// Worked out again whenever the user's permissions are re-read (practice switch, a role change pushed
		// from the server, coming back to the tab), so the dashboard never offers or loads on stale permissions.
		function applyPermissions() {
			// Which kind of note the "(ADD)" link starts; null when the user may write none.
			$scope.progressNoteTypeToAdd = Session.defaultProgressNoteType();
			$scope.canViewClinicalRecord = Session.hasPermission("CLINICAL_RECORD_VIEW");
			$scope.canManageOutboundCalls = Session.hasPermission("AI_OUTBOUND_CALL_MANAGE");
			$scope.showWorkupButton = Session.canStartWorkup();
			$scope.showOperationNoteButton = Session.hasPermission("SURGERY_OPERATION_NOTE_WRITE");
		}
		$scope.$watch(function () {
			return Session.permissions;
		}, applyPermissions);
		applyPermissions();
		$scope.$ctrl.sendEmr = false;

		// Data Collections
		$scope.OperationNoteList_chart = null;
		$scope.diagnosisData_ocular = [];
		$scope.diagnosisData_systemic = [];
		$scope.progressNoteData = [];
		$scope.uploadedDocuments = [];
		$scope.documentFilter = [];
		$scope.dateArray = [];
		$scope.pathwayFilter = [{ id: '', title: 'All' }, { id: 'Cataract', title: 'Cataract' }];

		$scope.today = new Date();
		$scope.datePickerOptions = { datepickerMode: 'month', minMode: 'month', showWeeks: false };

		// The details form (patientDetailsForm) while it is open: it writes the address and date of birth onto
		// the patient before a save. Null while the form is closed.
		let detailsForm = null;
		$scope.registerDetailsForm = function (form) {
			detailsForm = form;
		};

		// Callback Handlers
		let fetchPatientVision = null;
		let fetchPatientsMedication = null;
		let fetchDocumentHandler = null;
		let previewDocumentHandler = null;

		// Duplicate detection while registering a new patient. `duplicateCheckTimer`
		// debounces the lookup as the identifying fields are typed, and
		// `acknowledgedDuplicates` holds the detail keys the user has already chosen
		// to register anyway, so they are only asked once per set of details.
		let duplicateCheckTimer = null;
		let acknowledgedDuplicates = {};
		let promptedDuplicateKey = null;
		$scope.duplicatePatient = null;

		// ==========================================
		// LIFECYCLE HOOKS & WATCHERS
		// ==========================================
		this.$onInit = function () {
			if ($scope.CP.patient) {
				$scope.CP.patient.searchingForPractitioners = true;
				if ($scope.CP.patient.id) {
					$scope.showPatientEdit = false;
					$scope.showEditButton = true;
				}
			}

			_setupPracticeFeatures();
			_initializePatientData();

			// Fire initial data fetches
			fetchPatientDiagnosis();
			fetchProgressNote();
			fetchScheduledCalls();
			fetchPatientAiConversations();
			fetchInjectionNotes();
			requestOperationNote();

			subscribeToLiveRecordChanges();
		};

		// Another user's changes to this record, applied as they happen. Each event refreshes only the
		// section it names, in the background: no spinner, no timeline redraw, no documents re-fetch
		// riding along - documents have their own events. The same fetches run with a spinner after
		// the user's own save; the difference is only the background flag. Allergies are not here: the
		// header owns that fetch, and it is the header that subscribes. See PatientRecordLiveUpdateService.
		/** One patient-details refresh at a time - see _refreshPatientDetailsFromServer(). */
		var patientDetailsRefreshInFlight = false;

		/** A transfer is announced once. The poll can redeliver, and the user only leaves once. */
		var transferredOutHandled = false;

		/** A transfer held back until the microphone stops - see _sayTransferredOutAndLeave(). */
		var transferredOutPending = null;

		function subscribeToLiveRecordChanges() {
			const openPatientId = function () {
				return $scope.CP.patient && $scope.CP.patient.id;
			};
			const quietly = { background: true };

			PatientRecordLiveUpdateService.subscribeProgressNotes($scope, {
				patientId: openPatientId,
				reload: refreshProgressNotesQuietly,
			});

			// Concepts extracted onto a note or a conversation, seconds after it was saved. Which list
			// is re-read depends on which record they landed on. The diagnoses and allergies the same
			// extraction may have created arrive as their own events and refresh their own sections.
			PatientRecordLiveUpdateService.subscribeSnomedExtraction($scope, {
				patientId: openPatientId,
				onExtracted: function (payload) {
					if (payload.sourceType === "PATIENT_AI_CONVERSATION") {
						refreshAiConversationsQuietly();
					} else {
						refreshProgressNotesQuietly();
					}
				},
			});

			PatientRecordLiveUpdateService.subscribeVision($scope, {
				patientId: openPatientId,
				reload: function () {
					// The vision table registers its own fetch with the dashboard on init; it is absent
					// only if the table is not on the page, in which case there is nothing to redraw.
					if (fetchPatientVision) {
						fetchPatientVision(quietly);
					}
				},
			});

			PatientRecordLiveUpdateService.subscribeMedications($scope, {
				patientId: openPatientId,
				reload: function () {
					// Registered by the medication tile on init, the same way as the vision table.
					if (fetchPatientsMedication) {
						fetchPatientsMedication(quietly);
					}
				},
			});

			PatientRecordLiveUpdateService.subscribeDiagnoses($scope, {
				patientId: openPatientId,
				reload: function () {
					fetchPatientDiagnosis(quietly);
				},
			});

			// The patient's own details, as against a section of their record. This one cannot always
			// be applied quietly like the rest: the patient object is what the edit form is bound to,
			// so replacing it under someone who is part-way through typing takes their work away
			// without saying anything. Read the record and it is taken silently; edit it and it is
			// said first. See _refreshPatientDetailsFromServer().
			PatientRecordLiveUpdateService.subscribePatientDetails($scope, {
				patientId: openPatientId,
				onUpdated: function (payload) {
					_refreshPatientDetailsFromServer(payload);
				},
			});

			// The patient leaving this practice altogether. Subscribed here rather than in the header,
			// which sits on every page of the record: this is the dashboard and the details form, which
			// is where the brief asks for it, and a user part-way through a note elsewhere should not be
			// thrown out of it by a modal.
			PatientRecordLiveUpdateService.subscribePatientTransferredOut($scope, {
				patientId: openPatientId,
				onTransferredOut: _sayTransferredOutAndLeave,
			});
		}

		/**
		 * The open patient has moved to another practice. There is nothing to refresh and nothing to go
		 * back to - the record is not ours to read any more - so this says so and then leaves it.
		 *
		 * The patient is cleared before navigating so nothing downstream keeps showing a record this
		 * practice no longer holds. Static backdrop and no keyboard dismissal, for the same reason the
		 * details dialog has them: the only way out is the button, which makes onHide the one place the
		 * leaving is done.
		 */
		function _sayTransferredOutAndLeave(payload) {
			if (transferredOutHandled) {
				return;
			}

			// Not while the microphone is live. This modal does not just interrupt - closing it leaves
			// the record for the welcome page, which tears down the recorder mid-consultation and loses
			// what has not been sent. The patient has already gone from this practice and will still
			// have gone in a few minutes, so the news waits for the recording to stop. Held rather than
			// dropped: the user still has to be told they are on a record that is no longer theirs.
			if (ChunkedRecordingService.isRecording) {
				if (!transferredOutPending) {
					transferredOutPending = payload;
					var stopWatching = $scope.$watch(function () {
						return ChunkedRecordingService.isRecording;
					}, function (stillRecording) {
						if (stillRecording) {
							return;
						}
						stopWatching();
						var held = transferredOutPending;
						transferredOutPending = null;
						_sayTransferredOutAndLeave(held);
					});
				}
				return;
			}

			transferredOutHandled = true;

			$scope.transferredToPracticeName = payload && payload.toPracticeName;
			$scope.transferredOutModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.patient-transferred-out.tpl.html",
				show: true,
				title: "PATIENT TRANSFERRED",
				backdrop: "static",
				keyboard: false,
				onHide: function () {
					$scope.CP.clearPatient();
					$state.go("welcome");
				},
			});
		}

		/**
		 * Re-reads the patient after another user changed their details, and applies it.
		 *
		 * The event names the patient and nothing else, so the details come from the same endpoint the
		 * record was loaded through, and so past the same permission checks. One request at a time: a
		 * save publishes a single event, but a poll can redeliver it, and two dialogs over one edit is
		 * one too many.
		 */
		function _refreshPatientDetailsFromServer(payload) {
			var patientId = $scope.CP.patient && $scope.CP.patient.id;
			if (!patientId || patientDetailsRefreshInFlight) {
				return;
			}
			patientDetailsRefreshInFlight = true;

			PatientAPI.getPatient(patientId).then(function (resp) {
				var fetched = resp.data;
				// The user can move to another patient while the request is in flight; applying this
				// one then would swap the record out from under them.
				if (!fetched || !$scope.CP.patient || String($scope.CP.patient.id) !== String(fetched.id)) {
					return;
				}

				// Nothing is being typed over, so the record just catches up - whoever saved it, including
				// this user saving the same patient somewhere else.
				if (!$scope.showPatientEdit) {
					_adoptPatientDetails(fetched);
					return;
				}
				_saySoThenAdopt(fetched, _changedBySomeoneElse(payload));
			}, function () {
				// A refresh that could not be made leaves the screen as it is. Nothing here is worth
				// interrupting the user over, and the next change to this patient raises its own event.
			}).finally(function () {
				patientDetailsRefreshInFlight = false;
			});
		}

		/**
		 * Takes the saved record as the one on screen. setPatient() moves the saved snapshot with it,
		 * so another user's change does not then read as an unsaved edit of ours.
		 */
		function _adoptPatientDetails(fetched) {
			// The details form follows the patient being replaced (see patientDetailsForm).
			$scope.CP.setPatient(fetched, $scope.CP.patient.appointment);
		}

		/**
		 * Says what happened before replacing what the user was typing, and applies the change either
		 * way: dismissing the dialog is not a way to keep editing a record that has already moved on.
		 */
		/**
		 * Whether the change came from someone other than the user reading this screen. Decides only
		 * how the dialog is worded: an edit made by this user in another tab still replaces what is
		 * being typed here, and saying "another user" about it would be untrue.
		 */
		function _changedBySomeoneElse(payload) {
			var me = Session.user && Session.user.id;
			var editor = payload && payload.updatedByUserId;
			return !(me && editor && String(me) === String(editor));
		}

		function _saySoThenAdopt(fetched, byAnotherUser) {
			function adopt() {
				if ($scope.CP.patient && String($scope.CP.patient.id) === String(fetched.id)) {
					_adoptPatientDetails(fetched);
				}
			}

			// The same modal this controller raises for a duplicate patient, so the two read as the same
			// kind of interruption. Static backdrop and no keyboard dismissal: the only way out is the
			// button, which is what makes onHide a reliable place to apply the change.
			$scope.detailsChangedByAnotherUser = byAnotherUser;
			$scope.detailsChangedModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.patient-details-changed.tpl.html",
				show: true,
				title: "PATIENT DETAILS CHANGED",
				backdrop: "static",
				keyboard: false,
				onHide: adopt,
			});
		}

		$scope.$on('$locationChangeStart', function (event, next, current) {
			if ($scope.showCommentsOnly) {
				event.preventDefault();
				$scope.showCommentsOnly = false;
				return;
			} else {
				$scope.CP.clearPatient();
				event.preventDefault();
				return;
			}
		});

		$scope.$watch("CP.patient.id", function (newValue) {
			if (newValue) {
				$scope.dashboardReload();
			}
		}, true);

		// While registering, check for an existing record as soon as the form holds
		// enough to identify the patient - waiting for SAVE only earns them a 409.
		$scope.$watchGroup(
			["CP.patient.firstName", "CP.patient.lastName", "CP.patient.nhi",
				function () { return _showingDate().DD; },
				function () { return _showingDate().MM; },
				function () { return _showingDate().YYYY; }],
			function () { _scheduleDuplicateCheck(); }
		);

		// The date of birth as typed into the details form, which holds it as three boxes until a save.
		function _showingDate() {
			return (detailsForm && detailsForm.getShowingDate()) || {};
		}

		// An imported patient waiting for review: the review opens over the record as soon as it is open, to
		// merge it into the patient it duplicates or complete and confirm its details. Closed without finishing, the
		// user leaves the record too: it can't be used until it is reviewed. The review opens again with the record.
		$scope.$watch(function () {
			const patient = $scope.CP.patient;
			return patient && patient.id && patient.needs_review ? patient.id : null;
		}, function (pendingPatientId) {
			if (pendingPatientId) {
				_openImportReview(pendingPatientId);
			}
		});

		function _openImportReview(patientId) {
			PatientImportReview.open(patientId)
				.then(
					function (patient) {
						// The patient merged into, or this one confirmed. Re-read so the record has everything a load gives it.
						return PatientAPI.getPatient(patient.id).then(function (resp) {
							CurrentPatient.setPatient(resp.data);
						});
					},
					function () {
						// Closed without merging or confirming (the close button, Review later, or Return): leave the
						// record, back to the patient search. Unless the user has already moved to another patient.
						if ($scope.CP.patient && $scope.CP.patient.id === patientId) {
							CurrentPatient.clearPatient();
						}
					}
				)
				.catch(angular.noop);
		}

		$scope.$on("$destroy", function () {
			if (duplicateCheckTimer) $timeout.cancel(duplicateCheckTimer);
		});

		// ==========================================
		// UI & SCOPE METHODS (Template Bindings)
		// ==========================================
		$scope.dashboardReload = function () {
			fetchPatientDiagnosis();
			$scope.refreshProgressNotes();
			$scope.ShareData.reloadAllergies($scope.CP.patient.id);
			if (fetchPatientVision) fetchPatientVision();
			if (fetchPatientsMedication) fetchPatientsMedication();
		};

		// --- Form & Edit Controls ---
		$scope.openEditForm = function () {
			if (!$scope.showCommentsOnly) {
				$timeout(function () { $scope.showPatientEdit = true; }, 200);
				$scope.showEditButton = false;
			}
		};

		$scope.collapse = function () {
			$scope.registrationError = null;
			$scope.showPatientEdit = false;
			$scope.showEditButton = true;
			if (!$scope.CP.patient.id) {
				$window.history.back(); // cancel new patient create
				return;
			}
			_discardEdits();
		};

		/**
		 * Cancel throws the edits away.
		 *
		 * Closing the form is not enough on its own: the typed values sit on CP.patient, which is the
		 * same object the patient header, the verified pills and the next open of this form all read
		 * from. Left there, a cancelled edit goes on showing as though it had been kept, and only a
		 * page reload puts it right.
		 *
		 * patientBackup is the patient as last saved, so it is exactly what to go back to. Copied on
		 * the way in so the restored patient is not the same object the next cancel restores from.
		 * The appointment is carried across by hand: it lives on CP.patient rather than on the saved
		 * record, and setPatient() clears it when it is not handed one.
		 */
		function _discardEdits() {
			var saved = $scope.CP.patientBackup;
			if (!saved || !saved.id) {
				return;
			}

			// The details form follows the patient being replaced (see patientDetailsForm).
			$scope.CP.setPatient(angular.copy(saved), $scope.CP.patient.appointment);
		}

		$scope.cancel = function () {
			$scope.registrationError = null;
			$scope.CP.clearPatient();
		};

		// --- Patient Registration & Updates ---
		$scope.registerOrUpdatePatient = function () {
			// Guard against double submission: ignore further clicks while a save is
			// in flight (the SAVE button is also disabled until it resolves).
			if ($scope.isSubmitting) {
				return;
			}

			$scope.registrationError = null;

			if ($scope.CP.patient.id) {
				saveChanges();
				return;
			}

			$scope.isSubmitting = true;
			$scope.PA.isProcessing = true;

			// The debounced check may not have run yet if SAVE came quickly, so take
			// the last look here rather than let the create come back as a 409.
			_findUnacknowledgedDuplicate().then(function (found) {
				if (!found) {
					_sendRegistration();
					return;
				}
				$scope.isSubmitting = false;
				$scope.PA.isProcessing = false;
				_showDuplicateFound(found.patient, found.key);
			});
		};

		function _sendRegistration() {
			$scope.CP.patient.practice = { id: Session.practice.id };

			// The address picked from the lookup and the date of birth's boxes go onto the patient; an NZ address
			// typed rather than picked stops here, with the field selected and flagged.
			if (!detailsForm || !detailsForm.prepareForCreate()) {
				$scope.PA.isProcessing = false;
				$scope.isSubmitting = false;
				return;
			}

			$scope.registrationError = null;

			$scope.PA.create($scope.CP.patient, $scope.$ctrl.sendEmr).then(
				function (resp) {
					$scope.CP.setPatient(resp.data);
					// _initializePatientData() only records a visit for a patient that already
					// had an id when the page loaded, so a patient registered here would not
					// reach the recent list until they were next opened from search.
					PatientAPI.addToRecentPatients(resp.data.id);
					// Only a created patient has a record to go back and edit, so the
					// form is collapsed here rather than for every outcome.
					$scope.showEditButton = true;
					$scope.showPatientEdit = false;
					// Registered from a booking in the calendar - back to that booking, now with them in it.
					if (_resumeBookingForNewPatient(resp.data)) {
						$scope.hideSaveButton = false;
						return;
					}
					$scope.successfulEditModal = $modal({
						scope: $scope, templateUrl: "app/src/views/templates/modal.successful-edit.tpl.html", show: true, title: "SUCCESS",
						onHide: function () {
							$scope.showPatientEdit = false;
							$scope.hideSaveButton = false;
						},
					});
				},
				function (err) {
					console.error("Patient registration failed", err && err.status);
					// The patient was never created, so leave the form open and filled in:
					// collapsing it would strand the user with a half-registered patient
					// they cannot open and details they would have to retype.
					$scope.showPatientEdit = true;
					$scope.showEditButton = false;
					_showRegistrationError(err);
				}
			).finally(function () {
				$scope.PA.isProcessing = false;
				$scope.isSubmitting = false;
			});
		}

		/**
		 * The calendar's "Create new patient" sets the half-made booking aside (ShareData). With the patient
		 * now registered, the calendar opens again on that booking with them filled in. False when there is
		 * no booking waiting.
		 */
		function _resumeBookingForNewPatient(patient) {
			const booking = ShareData.getBookingAwaitingPatient();
			if (!booking || booking.patientId || !patient || !patient.id) {
				return false;
			}
			ShareData.setBookingAwaitingPatient({ ...booking, patientId: patient.id });

			toast.create({
				timeout: 6 * 1000,
				message: patient.firstName + " " + patient.lastName + " has been registered. Finish their appointment below.",
				className: "alert-success",
				dismissible: true
			});
			$mdDialog.show({
				controller: "calendarController",
				templateUrl: "app/src/views/templates/calendar.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				openFrom: "#anchor",
				closeTo: "#anchor",
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					patientId: () => patient.id,
					patientName: () => patient.firstName + " " + patient.lastName,
					selectedAppointment: () => null,
				},
			});
			return true;
		}

		/**
		 * Tells the user why the registration failed and keeps the reason on the form,
		 * so it is still there after the modal is dismissed and they start correcting
		 * the details. A 409 keeps its own modal - that one explains what to change.
		 */
		function _showRegistrationError(err) {
			const status = _errorStatus(err);

			if (status === 409) {
				$scope.registrationError = {
					message: "This patient already exists in CatTrax. Check their details - to register a different patient with the same name and date of birth, enter their NHI.",
				};
				// The modal shows the date of birth as typed into the details form.
				$scope.showingDate = _showingDate();
				$scope.duplicateModal = $modal({
					scope: $scope, templateUrl: "app/src/views/templates/modal.duplicate-patient.tpl.html", show: true, title: "DUPLICATE PATIENT", backdrop: "static", keyboard: false,
				});
				return;
			}

			$scope.registrationError = { message: _registrationFailureMessage(status) };

			// _showServerError() only opens when there is no modal already on screen, so
			// clear a stale one (e.g. an earlier NHI lookup failure) to be sure this is seen.
			if ($scope.serverErrorModal) {
				$scope.serverErrorModal.hide();
				$scope.serverErrorModal = null;
			}
			$scope.alertMessage = $scope.registrationError.message;
			_showServerError("Patient not registered");
		}

		function _registrationFailureMessage(status) {
			if (!status || status < 0) {
				return "We could not reach CatTrax to register this patient. Check your internet connection and press SAVE again - nothing you have entered has been lost.";
			}
			if (status === 401 || status === 403) {
				return "You are not allowed to register a patient at this practice. The details you entered have been kept - please check with your practice administrator.";
			}
			if (status === 400) {
				return "Some of this patient's details were rejected. Please correct them below and press SAVE again.";
			}
			return "We could not register this patient. Their details have been kept - please check them and press SAVE again.";
		}

		function _errorStatus(err) {
			if (!err) return null;
			// $http reports the HTTP status; the API also repeats it in the error body,
			// which is what the pre-existing duplicate handling reads.
			return err.status || (err.data && err.data.status) || null;
		}

		// --- Duplicate Patient Prompt ---
		$scope.openDuplicatePatient = function () {
			const existing = $scope.duplicatePatient;
			_hideDuplicateFoundModal();
			if (existing) _openRegisteredPatient(existing);
		};

		$scope.continueCreatingPatient = function () {
			// Remember the decision so the prompt does not reappear for these details.
			if (promptedDuplicateKey) acknowledgedDuplicates[promptedDuplicateKey] = true;
			_hideDuplicateFoundModal();
		};

		// --- Navigation & States ---
		$scope.startReferral = function () {
			$scope.PA.isProcessing = true;
			$scope.RA.startReferral().then(
				function (resp) {
					$scope.CR.setReferral(resp.data);
					$scope.PA.isProcessing = false;
					$state.go("examination");
				},
				function (err) { console.error("Start referral failed", err && err.status); $scope.PA.isProcessing = false; }
			);
		};

		$scope.startWorkUp = function () { $state.go("pre-op"); };
		$scope.startOperationNote = function () { $state.go("operation-note"); };
		$scope.startInjectionNote = function () { $state.go("injection-note"); };
		$scope.startClinicalNote = function () { $state.go("clinical-note"); };
		$scope.startAgain = function () {
			$scope.traceSuccessModal && $scope.traceSuccessModal.hide();
			$window.history.back();
		};
		$scope.backToDashboard = function () {
			$scope.traceSuccessModal && $scope.traceSuccessModal.hide();
		};

		// --- Modals & Popovers ---

		$scope.openScheduleModal = () => {
			window.scrollTo({ top: 0, behavior: 'instant' });
			$mdDialog.show({
				controller: "agentSettingController", templateUrl: "app/src/js/components/aiAgentSetting/agent-setting.tmpl.html", parent: angular.element(document.body),
				clickOutsideToClose: false, openFrom: "#anchor", closeTo: "#anchor", scope: $scope.$new(true), preserveScope: true,
				resolve: { isTabsView: () => false, patientId: () => $scope.CP.patient.id },
			}).then(() => { $scope.refreshProgressNotes(); });
		};

		// --- Diagnoses ---
		InfoPopoverHover.attach($scope);

		$scope.showDiagnosis = function (type) {
			$scope.closeInfoPopover();
			$scope.diagnosis = { comment: '', date_onset: $filter("date")(new Date(), "dd-MMMM-yyyy") };
			$scope.diagnosis_type = type;
			$scope.diagnosisModal = $modal({
				scope: $scope, templateUrl: "app/src/views/templates/modal.diagnosis.tpl.html", show: true, title: "DIAGNOSES AND PROCEDURES", backdrop: "static", keyboard: false,
				onHide: function () {
					$scope.closeInfoPopover();
				},
			});
		};

		$scope.diagnosisCallback = function (form) { $scope.diagnosis = { ...$scope.diagnosis, ...form }; };

		$scope.patientDiagnosisApi = {};

		$scope.saveDiagnosis = function () {
			// Guard against double submission: ignore further clicks while a save is
			// in flight (the Save button is also disabled until it resolves).
			if ($scope.isSubmittingDiagnosis) {
				return;
			}
			$scope.isSubmittingDiagnosis = true;
			$scope.DiagnosisAPI.isProcessing = true;
			let diagnosisArray = _buildDiagnosisPayload();

			$scope.DiagnosisAPI.saveDiagnosis($scope.CP.patient.id, diagnosisArray).then(
				function (resp) { },
				function (err) { console.error("Save diagnosis failed", err && err.status); }
			).then(function () {
				// $scope.diagnosisModal.hide();
				$scope.patientDiagnosisApi.resetForm();
				// clear comment field
				$scope.diagnosis.comment = '';
				fetchPatientDiagnosis();
				$scope.DiagnosisAPI.isProcessing = false;
				$scope.isSubmittingDiagnosis = false;
			});
		};

		// Diagnosis ids with a PATCH in flight. Rejecting is a soft delete server-side, so a
		// second click on the same row while the first is still going fails - ignore repeat
		// clicks until it settles.
		$scope.diagnosisInFlight = {};

		// The row was fetched for a particular patient. Reading CP.patient.id at click time
		// can pair the patient now open with a diagnosis belonging to the one before them,
		// so go by the patient the diagnosis itself says it belongs to.
		function _diagnosisPatientId(diagnosis) {
			return (diagnosis && diagnosis.patient_id) || $scope.CP.patient.id;
		}

		function _startDiagnosisUpdate(diagnosis) {
			if (!diagnosis || !diagnosis.diagnosis_id || $scope.diagnosisInFlight[diagnosis.diagnosis_id]) {
				return false;
			}
			$scope.diagnosisInFlight[diagnosis.diagnosis_id] = true;
			$scope.DiagnosisAPI.isProcessing = true;
			return true;
		}

		function _finishDiagnosisUpdate(diagnosis) {
			delete $scope.diagnosisInFlight[diagnosis.diagnosis_id];
			$scope.DiagnosisAPI.isProcessing = false;
			fetchPatientDiagnosis();
		}

		// A rejected diagnosis is gone as far as the server is concerned, so drop it from the
		// lists straight away rather than leaving a clickable row up until the refresh lands.
		function _dropDiagnosisFromLists(diagnosis_id) {
			const clearRow = function (row) {
				if (row.od && row.od.diagnosis_id === diagnosis_id) row.od = null;
				if (row.os && row.os.diagnosis_id === diagnosis_id) row.os = null;
				return row;
			};
			const hasDiagnosis = function (row) { return !!(row.od || row.os); };

			$scope.diagnosisData_systemic = ($scope.diagnosisData_systemic || []).filter(d => d.diagnosis_id !== diagnosis_id);
			// Both ocular lists share their row objects, so clearing one clears the other too.
			$scope.diagnosisData_ocular = ($scope.diagnosisData_ocular || []).map(clearRow).filter(hasDiagnosis);
			$scope.diagnosisData_ocular_simple = ($scope.diagnosisData_ocular_simple || []).map(clearRow).filter(hasDiagnosis);
		}

		$scope.removeDiagnosis = function (diagnosis) {
			if (!_startDiagnosisUpdate(diagnosis)) return;
			$scope.DiagnosisAPI.inactivateDiagnosis(_diagnosisPatientId(diagnosis), diagnosis.diagnosis_id).then(
				function (resp) { }, function (err) { console.error("Diagnosis update failed", err && err.status); }
			).then(function () {
				_finishDiagnosisUpdate(diagnosis);
			});
		};

		$scope.acceptDiagnosis = function (diagnosis) {
			if (!_startDiagnosisUpdate(diagnosis)) return;
			$scope.DiagnosisAPI.verifyDiagnosis(_diagnosisPatientId(diagnosis), diagnosis.diagnosis_id, "VERIFIED").then(
				function (resp) { }, function (err) { console.error("Diagnosis update failed", err && err.status); }
			).then(function () {
				_finishDiagnosisUpdate(diagnosis);
			});
		};

		$scope.rejectDiagnosis = function (diagnosis) {
			if (!_startDiagnosisUpdate(diagnosis)) return;
			const diagnosis_id = diagnosis.diagnosis_id;
			$scope.DiagnosisAPI.verifyDiagnosis(_diagnosisPatientId(diagnosis), diagnosis_id, "REJECTED").then(
				function (resp) { }, function (err) { console.error("Diagnosis update failed", err && err.status); }
			).then(function () {
				_finishDiagnosisUpdate(diagnosis);
			});
			_dropDiagnosisFromLists(diagnosis_id);
		};

		// --- Edit an existing diagnosis ---
		// The fields a user may change on an existing diagnosis, keyed by API field name. Each
		// entry says how the stored value appears in the edit form and how the form value goes
		// back to the API. To make another field editable: add an entry here and an input bound
		// to diagnosisEdit.form.<field> in modal.diagnosis-edit.tpl.html. The PATCH only carries
		// the fields whose value changed.
		const DIAGNOSIS_EDITABLE_FIELDS = {
			date_diagnosis_onset: {
				toForm: (value) => value ? $filter("date")(new Date(value), "dd-MMMM-yyyy") : null,
				toPayload: (value) => $filter("date")(new Date(value), "yyyy/MM/dd"),
			},
		};

		$scope.editDiagnosis = function (diagnosis) {
			if (!diagnosis || !diagnosis.diagnosis_id) return;
			$scope.closeInfoPopover();

			const form = {};
			Object.keys(DIAGNOSIS_EDITABLE_FIELDS).forEach(function (key) {
				form[key] = DIAGNOSIS_EDITABLE_FIELDS[key].toForm(diagnosis[key]);
			});

			// The datepicker's date-set wants a string Date.parse understands.
			const onsetDateSet = (diagnosis.date_diagnosis_onset ? new Date(diagnosis.date_diagnosis_onset) : $scope.today).toString();

			$scope.diagnosisEdit = {
				diagnosis: diagnosis,
				form: form,
				original: angular.copy(form),
				// Left empty until the modal is up - see onShow below.
				onsetDateSet: null,
			};
			$scope.diagnosisEditModal = $modal({
				scope: $scope, templateUrl: "app/src/views/templates/modal.diagnosis-edit.tpl.html", show: true, title: "EDIT DIAGNOSIS", backdrop: "static", keyboard: false,
				onShow: function () {
					// angularjs-datepicker boots by applying date-set, then snapping its selected day to
					// date-max-limit (today), then writing that selected day into the input - so a date-set
					// given up front is lost and every diagnosis would open on today. Setting date-set once
					// the modal is up re-fires its watcher after that snap, landing the field and the
					// calendar on the diagnosis' own onset date.
					$timeout(function () {
						if ($scope.diagnosisEdit && $scope.diagnosisEdit.diagnosis === diagnosis) {
							$scope.diagnosisEdit.onsetDateSet = onsetDateSet;
						}
					});
				},
			});
		};

		$scope.diagnosisEditHasChanges = function () {
			const edit = $scope.diagnosisEdit;
			return !!edit && Object.keys(DIAGNOSIS_EDITABLE_FIELDS).some(key => edit.form[key] !== edit.original[key]);
		};

		$scope.saveDiagnosisEdit = function () {
			const edit = $scope.diagnosisEdit;
			if (!edit || !$scope.diagnosisEditHasChanges()) return;

			const fields = {};
			Object.keys(DIAGNOSIS_EDITABLE_FIELDS).forEach(function (key) {
				if (edit.form[key] !== edit.original[key]) {
					fields[key] = DIAGNOSIS_EDITABLE_FIELDS[key].toPayload(edit.form[key]);
				}
			});

			if (!_startDiagnosisUpdate(edit.diagnosis)) return;
			$scope.DiagnosisAPI.updateDiagnosis(_diagnosisPatientId(edit.diagnosis), edit.diagnosis.diagnosis_id, fields).then(
				function () { $scope.closeDiagnosisEditModal(); },
				function () { _showServerError("Unable to save the diagnosis changes"); }
			).then(function () {
				_finishDiagnosisUpdate(edit.diagnosis);
			});
		};

		// Remove (inactivate) the diagnosis open in the edit modal, once the user has confirmed it
		// there. Inactive diagnoses are hidden from the lists, so drop the row once the server agrees.
		$scope.removeDiagnosisFromEdit = function () {
			const edit = $scope.diagnosisEdit;
			if (!edit || !$scope.canWriteDiagnosis() || !_startDiagnosisUpdate(edit.diagnosis)) return;
			const diagnosis_id = edit.diagnosis.diagnosis_id;
			$scope.DiagnosisAPI.inactivateDiagnosis(_diagnosisPatientId(edit.diagnosis), diagnosis_id).then(
				function () {
					$scope.closeDiagnosisEditModal();
					_dropDiagnosisFromLists(diagnosis_id);
				},
				function () {
					edit.confirmRemove = false;
					_showServerError("Unable to remove the diagnosis");
				}
			).then(function () {
				_finishDiagnosisUpdate(edit.diagnosis);
			});
		};

		$scope.closeDiagnosisEditModal = function () {
			if ($scope.diagnosisEditModal) {
				$scope.diagnosisEditModal.hide();
				$scope.diagnosisEditModal = null;
			}
		};

		// --- Notes & Comments ---
		$scope.addComment = function () {
			// Guard against double submission: ignore further clicks while the comment
			// is in flight (the button is also disabled until it resolves).
			if ($scope.isSubmittingComment) {
				return;
			}
			$scope.isSubmittingComment = true;

			const body = { op_note_od_comment: $scope.OperationNote.op_note_od.comment, op_note_os_comment: $scope.OperationNote.op_note_os.comment };
			OperationAPI.addNewComment($scope.OperationNote.patient_id, $scope.OperationNote.operation_note_id, body).then(function (resp) {
				$scope.showCommentsOnly = false;
			}).catch(function (error) {
				console.error("append comment failed", error && error.status);
				_showServerError();
			}).finally(function () {
				$scope.isSubmittingComment = false;
			});
		};

		$scope.addInjectionComment = function () {
			// Guard against double submission: ignore further clicks while the comment
			// is in flight (the button is also disabled until it resolves).
			if ($scope.isSubmittingComment) {
				return;
			}
			$scope.isSubmittingComment = true;

			const body = { injection_note_od_comment: $scope.OperationNote.op_note_od.comment, injection_note_os_comment: $scope.OperationNote.op_note_os.comment };
			InjectionNoteAPI.addNewComment($scope.OperationNote.patient_id, $scope.OperationNote.injection_note_id, body).then(function (resp) {
				$scope.showCommentsOnly = false;
			}).catch(function (error) {
				console.error("append comment failed", error && error.status);
				_showServerError();
			}).finally(function () {
				$scope.isSubmittingComment = false;
			});
		};

		$scope.hideComment = function () {
			$scope.OperationNote = {};
			$scope.showCommentsOnly = false;
		};

		$scope.showProgressNoteModal = function (obj) {
			if (obj) {
				$scope.progressNoteObj = obj;
			} else {
				$scope.progressNoteObj = _buildEmptyProgressNote();
			}
			$scope.progressNoteModal = $modal({
				scope: $scope, templateUrl: "app/src/views/templates/modal.progress-note.tpl.html", show: true, title: "Progress Note", backdrop: "static", keyboard: false,
			});
		};

		$scope.askProgressNoteModal = function () {
			$scope.alertMessage = 'Are you sure to quit progress note ?';
			$scope.modalInstance = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html", show: true, title: "Progress note is not submitted yet" });
		};

		$scope.closeFileUploadErrorModal = function () {
			if ('Are you sure to quit progress note ?' === $scope.alertMessage) $scope.progressNoteModal.hide();
			if ('Are you sure to quit adding diagnosis ?' === $scope.alertMessage) $scope.diagnosisModal.hide();
			$scope.alertMessage = null;
			$scope.modalInstance.hide();
		};

		// Whether a fetch was asked for by a live update rather than by the user. A live update must not
		// show a spinner or reset anything: it is happening to a screen the user did not touch.
		function isBackground(options) {
			return !!(options && options.background);
		}

		// The four sources the notes timeline is folded from, kept apart so one can be refreshed on its
		// own. A live change to a progress note re-asks for the notes and nothing else.
		let timelineSources = { notes: [], calls: [], conversations: [], injections: [] };

		function combineTimeline() {
			$scope.progressNoteData = timelineSources.notes
				.concat(timelineSources.calls, timelineSources.conversations, timelineSources.injections)
				.sort((a, b) => new Date(a.date_of_consult || 0) - new Date(b.date_of_consult || 0));
		}

		$scope.refreshProgressNotes = function () {
			$q.all([fetchProgressNote(), fetchScheduledCalls(), fetchPatientAiConversations(), fetchInjectionNotes()]).then(function (results) {
				timelineSources = { notes: results[0], calls: results[1], conversations: results[2], injections: results[3] };
				combineTimeline();
				$scope.PNAPI.isProcessing = false;
			});
			fetchPatientDocument();
		};

		// Another user's note change, or the SNOMED concepts landing on a note. Only the notes are
		// re-fetched, with no spinner; the documents list has its own events and the other timeline
		// sources did not change.
		function refreshProgressNotesQuietly() {
			fetchProgressNote({ background: true }).then(function (notes) {
				timelineSources.notes = notes;
				combineTimeline();
			});
		}

		// The SNOMED concepts landing on an AI conversation. Only the conversations are re-fetched;
		// that fetch has no spinner of its own.
		function refreshAiConversationsQuietly() {
			fetchPatientAiConversations().then(function (conversations) {
				timelineSources.conversations = conversations;
				combineTimeline();
			});
		}

		$scope.onProgressNoteSuccess = function () {
			if ($scope.progressNoteModal) $scope.progressNoteModal.hide();
			$scope.refreshProgressNotes();
		};

		// Issuing a lens prescription saves the patient's copy to their documents.
		$scope.$on("lensPrescribing:document", function (event, patientId) {
			if ($scope.CP.patient && $scope.CP.patient.id === patientId) fetchPatientDocument();
		});

		// --- Utilities & Handlers Bound to UI ---
		$scope.refreshprescription = function () { fetchPatientDocument(); };
		$scope.refreshDocuments = function () { fetchPatientDocument(); };
		// Sending a lens order saves its PDF to the patient's documents - from the dispensing tile or
		// the practice's job list, which can be open over this patient.
		$scope.$on("lensDispensing:document", function (event, patientId) {
			if ($scope.CP.patient && $scope.CP.patient.id === patientId) fetchPatientDocument();
		});
		$scope.onVisionUpdate = function () {
			fetchPatientDocument();
			$scope.showTimeline = false;
			setTimeout(() => { $scope.showTimeline = true; }, 500);
		};

		$scope.documentEvent = function (document) {
			if (document) {
				$scope.showCommentsOnly = true;
				$scope.hiddenFooter = false;
				$scope.operative_eye = document.operative_eye;
				$scope.disableSelect = document.disableSelect;
				$scope.OperationNote = document.operationNote;
			}
		};

		$scope.previewFile = function (file) {
			// Passed through so the file is read under the patient it was listed against, not whoever
			// happens to be loaded now.
			if (previewDocumentHandler) previewDocumentHandler(file.document_id, file.document_type, file.full_name || file.file_name, file.patient_id);
		};

		$scope.filesFetched = function (uploadedDocuments) {
			if (uploadedDocuments) $scope.uploadedDocuments = uploadedDocuments;
		};

		$scope.registerVisionHandler = function (handler) { fetchPatientVision = handler; };
		$scope.registerMedicationHandler = function (handler) { fetchPatientsMedication = handler; };
		$scope.registerDocumentsHandler = function (fetch, preview) {
			fetchDocumentHandler = fetch;
			previewDocumentHandler = preview;
		};


		$scope.trimLongText = function (text) {
			return (text && text.length > 30) ? text.substring(0, 27) + "..." : text;
		};

		$scope.formatDate = function (_date) {
			if (_date) {
				const date = new Date(_date);
				return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
			}
			return "";
		};

		$scope.canWriteDiagnosis = function () {
			return Session.hasPermission("CLINICAL_DIAGNOSIS_WRITE");
		};


		// ==========================================
		// DATA FETCHING (Private Methods)
		// ==========================================
		function fetchPractitioners() {
			const cachedGP = $scope.CP.getGP($scope.CP.patient.id);
			if (cachedGP) {
				$scope.CP.patient.practitioners = angular.copy([cachedGP]);
				return;
			}
			$scope.CP.patient.searchingForPractitioners = true;
			$scope.fetchPractitionersCanceller = $q.defer();
			PatientAPI.getPractitioners($scope.CP.patient.id, $scope.fetchPractitionersCanceller).then(function (resp) {
				$scope.CP.patient.practitioners = angular.copy(resp.data);
				$scope.CP.setGP($scope.CP.patient.id, $scope.CP.patient.practitioners);
				$scope.CP.patient.searchingForPractitioners = false;
			}, function (error) {
				$scope.CP.patient.searchingForPractitioners = false;
			});
		}

		function fetchPatientDiagnosis(options) {
			if (!$scope.CP.patient || !$scope.CP.patient.id || !Session.hasPermission("CLINICAL_DIAGNOSIS_VIEW")) return;
			const background = isBackground(options);
			if (!background) $scope.DiagnosisAPI.isProcessing = true;
			$scope.DiagnosisAPI.getDiagnosis($scope.CP.patient.id).then(
				function (resp) {
					if (resp.data) {
						const mapDiagnosis = (t) => ({
							...t,
							internal_type: t.snomed_concept.fsn.term.endsWith('(procedure)') ? 1 : 0,
							date_diagnosis_onset: new Date(t.date_diagnosis_onset),
						});

						// Active first with dashboard sort (AI/PENDING last), inactive after — matches dashboard list order
						const systemic = resp.data.filter(m => m.type === 'SYSTEMIC').map(mapDiagnosis);
						$scope.diagnosisData_systemic = $scope.DiagnosisAPI.sortDiagnosisItems(systemic.filter(t => t.status === 'ACTIVE'))
							.concat($scope.DiagnosisAPI.sortDiagnosisItems(systemic.filter(t => t.status !== 'ACTIVE')));

						const array = resp.data.filter(t => t.type === 'OCULAR').map(mapDiagnosis);

						const od_active = $scope.DiagnosisAPI.sortDiagnosisItems(array.filter(t => t.laterality === 'OD' && t.status === 'ACTIVE'));
						const os_active = $scope.DiagnosisAPI.sortDiagnosisItems(array.filter(t => t.laterality === 'OS' && t.status === 'ACTIVE'));
						const od_inactive = $scope.DiagnosisAPI.sortDiagnosisItems(array.filter(t => t.laterality === 'OD' && t.status !== 'ACTIVE'));
						const os_inactive = $scope.DiagnosisAPI.sortDiagnosisItems(array.filter(t => t.laterality === 'OS' && t.status !== 'ACTIVE'));

						const simple_rows = [];
						for (let i = 0; i < Math.max(od_active.length, os_active.length); i++) {
							simple_rows.push({ od: od_active[i] || null, os: os_active[i] || null });
						}

						// Modal: same active order as dashboard, then inactive rows underneath
						const rows = simple_rows.slice();
						for (let i = 0; i < Math.max(od_inactive.length, os_inactive.length); i++) {
							rows.push({ od: od_inactive[i] || null, os: os_inactive[i] || null });
						}

						$scope.diagnosisData_ocular = rows;
						$scope.diagnosisData_ocular_simple = simple_rows;
					}
				}, function (err) { console.error("Fetch diagnosis failed", err && err.status); }
			).then(function () { if (!background) $scope.DiagnosisAPI.isProcessing = false; });
		}

		function fetchProgressNote(options) {
			if (!$scope.CP.patient || !$scope.CP.patient.id || !$scope.canViewClinicalRecord) return $q.when([]);
			if (!isBackground(options)) $scope.PNAPI.isProcessing = true;
			return $scope.PNAPI.getProgressNotes($scope.CP.patient.id).then(function (resp) {
				return resp.data.map(t => ({
					...t,
					dateOfConsult: $filter("date")(new Date(t.date_of_consult), "dd-MMMM-yyyy"),
					dateOfEntry: $filter("date")(new Date(t.date_of_entry), "dd-MMMM-yyyy"),
					extracted_snomed_concepts: t.extracted_snomed_concepts || [],
				}));
			}, function (error) { return $q.when([]); });
		}

		function fetchScheduledCalls() {
			if (!$scope.isAIEnabled || !$scope.canManageOutboundCalls || !$scope.CP.patient || !$scope.CP.patient.id) return $q.when([]);
			return $scope.ElevenLabsAPI.getOutboundCallsByPatientId($scope.CP.patient.id, true).then(function (response) {
				return (response.data || []).filter(call => call.status === 'SCHEDULED' && call.date_scheduled_utc).map(function (call) {
					const scheduledDate = new Date(call.date_scheduled_utc);
					return {
						progress_note_id: `call-${call.outbound_call_id}`, progress_note_type: 'SCHEDULED_AI_CALL',
						consult_display: scheduledDate.toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' }) + ' @ ' + scheduledDate.toLocaleTimeString('en-NZ', { hour: 'numeric', minute: '2-digit', hour12: true }),
						date_of_consult: call.date_scheduled_utc, date_of_entry: new Date(call.date_created).toISOString().split('T')[0],
						created_by_user_full_name: call.scheduled_by_user_full_name || 'System', created_by_user_role_types: [],
						practice_name: $scope.Session.practice.name, is_soap_format: false, is_deleted: false, free_text: `Scheduled AI call to patient.`,
						security_level: 'PRACTICE', created_by_user_id: null
					};
				});
			}, function (error) { return $q.when([]); });
		}

		function fetchPatientAiConversations() {
			if (!$scope.CP.patient || !$scope.CP.patient.id) return $q.when([]);
			return $scope.PatientAiConversationAPI.getPatientAiConversationsByPatientId($scope.CP.patient.id).then(function (response) {
				return (response.data || []).map(function (conversation) {
					const createdDate = moment.utc(conversation.date_created).tz($scope.Session.practice.timezone);
					return {
						progress_note_id: `conversation-${conversation.patient_ai_conversation_id}`,
						progress_note_type: 'AI_CONVERSATION_NOTE',
						date_of_consult: createdDate.format('YYYY-MM-DD'),
						date_created: createdDate.format('YYYY-MM-DD'),
						date_of_entry: createdDate.format('YYYY-MM-DD'),
						created_by_user_full_name: conversation.agent_name,
						security_level: 'PRACTICE',
						free_text: conversation.summary,
						practice_name: conversation.practice_name,
						extracted_snomed_concepts: conversation.extracted_snomed_concepts
					};
				});
			}, function (error) { return $q.when([]); });
		}

		function fetchInjectionNotes() {
			if (!$scope.CP.patient || !$scope.CP.patient.id || !Session.hasPermission("CLINICAL_INJECTION_NOTE_VIEW")) return $q.when([]);
			return InjectionNoteAPI.getInjectionNotes($scope.CP.patient.id).then((response) => {
				return (response.data || []).map((injectionNote) => {
					const createdDate = moment.utc(injectionNote.date_created).tz($scope.Session.practice.timezone);
					return {
						progress_note_id: `inject-${injectionNote.injection_note_id}`, progress_note_type: 'INJECTION_NOTE',
						date_of_consult: createdDate.format('YYYY-MM-DD'), date_created: createdDate.format('YYYY-MM-DD'),
						date_of_entry: createdDate.format('YYYY-MM-DD'), created_by_user_full_name: injectionNote.completed_by_user_full_name || '',
						created_by_user_role_types: [], practice_name: $scope.Session.practice.name, is_soap_format: false, is_deleted: false,
						security_level: 'PRACTICE', created_by_user_id: injectionNote.completed_by_user_id,
						injection_note_od: injectionNote.injection_note_od, injection_note_os: injectionNote.injection_note_os,
						post_injection_care: injectionNote.post_injection_care
					};
				});
			}, function (error) { return $q.when([]); });
		}

		function fetchPatientDocument() {
			if (fetchDocumentHandler) fetchDocumentHandler();
		}

		function requestOperationNote() {
			if (!$scope.CP.patient || !$scope.CP.patient.id || !Session.hasPermission("SURGERY_OPERATION_NOTE_VIEW")) return;
			OperationAPI.getOperationNotes($scope.CP.patient.id).then(function () {
				if (OperationNote.noteList.length === 0) {
					$scope.OperationNote = OperationNote.data;
					$scope.OperationNoteList_chart = [];
				} else {
					$scope.OperationNoteList_chart = OperationNote.noteList;
				}
			});
		}

		function saveChanges() {
			// The address picked from the lookup and the date of birth's boxes go onto the patient; an NZ address
			// typed rather than picked stops here, with the field selected and flagged.
			if (!detailsForm || !detailsForm.prepareForUpdate()) {
				return false;
			}

			$scope.isSubmitting = true;
			$scope.PA.isProcessing = true;

			// Read before the save: setPatient() below replaces both the patient and the backup, so
			// afterwards there is nothing left to compare against.
			var contactsBefore = {
				email: ($scope.CP.patientBackup || {}).email,
				mobileNumber: ($scope.CP.patientBackup || {}).mobileNumber
			};

			// A failed save (other than the 409, which restores the saved record) leaves the form open
			// with the edits in it, so the unsaved values are not shown as though they had been kept.
			var keepFormOpen = false;

			$scope.PA.update($scope.CP.patient, $scope.$ctrl.sendEmr).then(
				function (resp) {
					var saved = resp.data || {};
					$scope.CP.setPatient(resp.data);
					_notifyIfVerificationSent(contactsBefore, saved);
				},
				function (err) {
					console.error("Patient update failed", err && err.status);
					if (err && err.data && err.data.status === 409) {
						// The modal shows the date of birth as typed into the details form.
						$scope.showingDate = _showingDate();
						$scope.duplicateModal = $modal({
							scope: $scope, templateUrl: "app/src/views/templates/modal.duplicate-patient.tpl.html", show: true, title: "DUPLICATE PATIENT", backdrop: "static", keyboard: false,
							onHide: function () { $scope.CP.setPatient($scope.CP.patientBackup); }
						});
					} else {
						keepFormOpen = true;
						_showServerError();
					}
				}
			).finally(function () {
				$scope.PA.isProcessing = false;
				$scope.isSubmitting = false;
				if (!keepFormOpen) {
					$scope.showPatientEdit = false;
					$scope.showEditButton = true;
				}
			});
		}


		/**
		 * Which channels a save would send a verification down, given the details before and after.
		 * Empty when it would send nothing.
		 *
		 * The condition mirrors checkAndSendPatientCommVerification() in
		 * BasePatientCommVerificationServiceImpl: a detail has to have changed, and there has to be a
		 * channel that can actually be reached. Duplicating the rule here is a known cost - if the
		 * server's changes, this says the wrong thing until it is updated to match. The alternative,
		 * having the update endpoint report what it sent, is the better answer if it ever drifts.
		 *
		 * One function so the button's promise and the toast's claim are the same rule. Two copies of
		 * this would eventually disagree, and the pair a user would notice is a button offering to
		 * verify followed by no toast.
		 */
		function _verificationChannels(previous, current) {
			if (!$scope.CP.isContactVerificationEnabled()) { return []; }

			previous = previous || {};
			current = current || {};

			var emailChanged = (previous.email || "") !== (current.email || "");
			var mobileChanged = (previous.mobileNumber || "") !== (current.mobileNumber || "");
			if (!emailChanged && !mobileChanged) { return []; }

			// A blanked-out detail cancels any outstanding token rather than sending a new one.
			// AU has no SMS gateway, so a mobile is not a channel that can be reached there.
			var channels = [];
			if (current.email) { channels.push("email"); }
			if (current.mobileNumber && countryConfig.mobileVerificationEnabled) { channels.push("text message"); }
			return channels;
		}

		/**
		 * The save button says what the save will actually do. Promising to verify on every save -
		 * including the ones that change nothing a patient would be told about - would train staff to
		 * stop reading it.
		 *
		 * Evaluated against the live form, so it changes as soon as an address or number is edited.
		 */
		$scope.saveButtonLabel = function () {
			return _verificationChannels($scope.CP.patientBackup, $scope.CP.patient).length
				? "SAVE AND VERIFY PATIENT CONTACTS"
				: "SAVE";
		};

		/**
		 * Tell the user when saving has just sent the patient a verification link, because nothing
		 * else on screen says so - the send happens server-side inside the save and the only other
		 * sign is a pill quietly flipping to Unverified.
		 */
		function _notifyIfVerificationSent(before, saved) {
			var sentTo = _verificationChannels(before, saved);
			if (!sentTo.length) { return; }

			toast.create({
				timeout: 6 * 1000,
				message: "Contact details saved. We have sent " + $scope.CP.patient.firstName
					+ " a " + sentTo.join(" and a ") + " asking them to confirm their details.",
				className: "alert-success",
				dismissible: true
			});
		}


		// ==========================================
		// DUPLICATE PATIENT DETECTION
		// ==========================================

		/** The identifying details, or null while they are still incomplete. */
		function _duplicateCheckDetails() {
			const patient = $scope.CP.patient || {};
			const date = _showingDate();
			const firstName = (patient.firstName || "").trim();
			const lastName = (patient.lastName || "").trim();

			// Mirrors the minimums the register form itself enforces, so we do not
			// search on half-typed names or years.
			if (firstName.length < 1 || lastName.length < 1) return null;
			if (!date.DD || !date.MM || !date.YYYY || String(date.YYYY).length !== 4) return null;

			return {
				firstName: firstName,
				lastName: lastName,
				nhi: (patient.nhi || "").trim(),
				dob: date.YYYY + "/" + date.MM + "/" + date.DD
			};
		}

		function _duplicateCheckKey(details) {
			return [details.firstName, details.lastName, details.dob, details.nhi].join("|").toLowerCase();
		}

		function _scheduleDuplicateCheck() {
			// Only relevant while registering: editing an existing patient keeps the
			// server-side conflict handling in saveChanges().
			if ($scope.CP.patient && $scope.CP.patient.id) return;

			if (duplicateCheckTimer) $timeout.cancel(duplicateCheckTimer);
			duplicateCheckTimer = $timeout(_runDuplicateCheck, 500);
		}

		/**
		 * Resolves with { patient, key } when the details on the form match a record the
		 * user has not already chosen to register alongside, otherwise null.
		 */
		function _findUnacknowledgedDuplicate() {
			const details = _duplicateCheckDetails();
			if (!details) return $q.resolve(null);

			const key = _duplicateCheckKey(details);
			if (acknowledgedDuplicates[key]) return $q.resolve(null);

			return PatientDuplicate.findExisting(details.firstName, details.lastName, details.dob, details.nhi)
				.then(function (existing) {
					return existing ? { patient: existing, key: key } : null;
				});
		}

		function _runDuplicateCheck() {
			duplicateCheckTimer = null;

			if ($scope.duplicateFoundModal) return;
			if ($scope.CP.patient && $scope.CP.patient.id) return;

			_findUnacknowledgedDuplicate().then(function (found) {
				if (!found || $scope.duplicateFoundModal) return;
				if ($scope.CP.patient && $scope.CP.patient.id) return;

				// The form may have moved on while the lookup was in flight.
				const current = _duplicateCheckDetails();
				if (!current || _duplicateCheckKey(current) !== found.key) return;

				_showDuplicateFound(found.patient, found.key);
			});
		}

		function _showDuplicateFound(existing, key) {
			$scope.duplicatePatient = existing;
			promptedDuplicateKey = key;
			$scope.duplicateFoundModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.duplicate-patient-found.tpl.html",
				show: true, title: "PATIENT ALREADY REGISTERED", backdrop: "static", keyboard: false,
			});
		}

		function _hideDuplicateFoundModal() {
			if (!$scope.duplicateFoundModal) return;
			// Leave duplicatePatient in place: the modal is still fading out and would
			// otherwise flash empty details on its way.
			$scope.duplicateFoundModal.hide();
			$scope.duplicateFoundModal = null;
		}

		/**
		 * Abandons the half-filled registration and opens the existing record. Clearing
		 * the patient first drops back to the search dashboard, so the following digest
		 * rebuilds this component against the real patient - the same handover the
		 * recent patients list and search results use.
		 */
		function _openRegisteredPatient(patient) {
			CurrentPatient.clearPatient();

			$timeout(function () {
				CurrentPatient.setPatient(patient);
				if (CurrentPatient.patientIsMine) return;

				// Registered to another practice: transferring them is the only way in.
				$modal({
					controller: "patientTransferController",
					templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
					show: true,
					backdrop: "static",
					resolve: {
						patientId: function () { return patient.id; },
						onSuccess: function () {
							return function (updatedPatient) { CurrentPatient.setPatient(updatedPatient); };
						},
						onCancel: function () {
							return function () { CurrentPatient.clearPatient(); };
						}
					}
				});
			});
		}

		// ==========================================
		// HELPER/UTILITY FUNCTIONS
		// ==========================================
		function _setupPracticeFeatures() {
			if (Session.practice.practiceFeatures) {
				let featureToggles = Session.practice.practiceFeatures;
				if (featureToggles.calendarFeature === true) $scope.CALENDAR_ENABLE = true;
				if (featureToggles.fhirNhiFeature) $scope.fhirNhiFeature = featureToggles.fhirNhiFeature;
				if (NEXT_OF_KIN_1070) $scope.isNextOfKinFeatureEnabled = true;
				if (featureToggles.elevenLabsAiAgentFeature) $scope.isAIEnabled = featureToggles.elevenLabsAiAgentFeature;
				if (featureToggles.nhiFeature === true || featureToggles.fhirNhiFeature === true) $scope.isNHIFeatureEnabled = true;
			}
		}

		function _initializePatientData() {
			if (!$scope.CP.patient || !$scope.CP.patient.id) {
				$scope.showEditButton = false;
				if ($scope.CP.patient) {
					$scope.CP.patient = { ...$scope.CP.patient, smokerAnswer: 'NOT_ASKED' };
				} else {
					$scope.CP.patient = { smokerAnswer: 'NOT_ASKED' };
				}
			}

			if ($scope.CP.patient && $scope.CP.patient.id) {
				let appointment = $scope.CP.patient.appointment ? angular.copy($scope.CP.patient.appointment) : null;
				PatientAPI.isProcessing = true;

				PatientAPI.getPatient($scope.CP.patient.id).then(function (resp) {
					CurrentPatient.setPatient(resp.data, appointment);
					if ($scope.fhirNhiFeature) fetchPractitioners();

					$scope.showPatientEdit = false;
					$scope.hideSaveButton = false;
				}, function (error) {
					_showServerError();
				}).then(function () {
					PatientAPI.isProcessing = false;
				});

				PatientAPI.addToRecentPatients($scope.CP.patient.id);
			}
		}

		function _buildDiagnosisPayload() {
			let diagnosisArray = [];
			const baseObj = {
				date_diagnosis_onset: $filter("date")(new Date($scope.diagnosis.date_onset), "yyyy/MM/dd"),
				search_term: $scope.diagnosis.diagnosis, note: $scope.diagnosis.comment, snomed_concept: { concept_id: $scope.diagnosis.diagnosis_object.concept_id }
			};

			if ($scope.diagnosis.diagnosis_type === 'ocular') {
				if ($scope.diagnosis.operative_eye === 'OU') {
					diagnosisArray = [{ ...baseObj, laterality: 'OD', type: 'OCULAR' }, { ...baseObj, laterality: 'OS', type: 'OCULAR' }];
				} else {
					diagnosisArray = [{ ...baseObj, laterality: $scope.diagnosis.operative_eye, type: 'OCULAR' }];
				}
			} else {
				diagnosisArray = [{ ...baseObj, type: 'SYSTEMIC' }];
			}
			return diagnosisArray;
		}

		function _buildEmptyProgressNote() {
			const time = new Date(); time.setSeconds(0, 0);
			var lname = $scope.Session.user.lastName || '';
			var fname = $scope.Session.user.firstName || '';
			const progressNoteSettings = Session.practice.practiceFeatures.progressNoteSettings;
			var progress_note_type = Session.defaultProgressNoteType() || 'PROGRESS_NOTE';

			return {
				is_soap_format: (progress_note_type == 'ADMIN_NOTE' || progress_note_type == 'NURSE_NOTE') ? false : progressNoteSettings ? progressNoteSettings.is_soap_format : false,
				security_level: (progress_note_type == 'ADMIN_NOTE' || progress_note_type == 'NURSE_NOTE') ? 'PRACTICE' : (progressNoteSettings && progressNoteSettings.security_level) ? progressNoteSettings.security_level : 'GLOBAL',
				progress_note_type: progress_note_type, booked_for_surgery_section: { booked_for_surgery: false },
				date_of_consult: $filter("date")(new Date(), "dd/MM/yyyy"), time_of_consult: time,
				date_of_entry: $filter("date")(new Date(), "dd/MM/yyyy"), time_of_entry: time,
				clinician: fname + ' ' + lname, practiceId: $scope.Session.practice.id, patientId: $scope.CP.patient.id,
				subjective_note: '', objective_note: '', assessment_note: '', plan_note: '',
			};
		}

		function _showServerError(title = "CatTrax has encountered an error") {
			// Always cleared so a detail from an earlier failure cannot trail into this one.
			$scope.alertDetail = null;
			// The template's "serverErrorModal = null" lands on the modal's child scope, not this one,
			// so a dismissed modal still leaves its instance here. Replace it rather than skip showing.
			if ($scope.serverErrorModal) {
				$scope.serverErrorModal.hide();
			}
			$scope.serverErrorModal = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.server-error.tpl.html", show: true, title: title });
		}

		$scope.$on("$destroy", () => {
			if ($scope.fetchPractitionersCanceller) {
				$scope.fetchPractitionersCanceller.resolve();
			}
		});

		$scope.askDiagnosisModal = function () {
			const isFormClean = !$scope.diagnosis.diagnosis_object;
			if (isFormClean) {
				return $scope.diagnosisModal.hide();
			};
			$scope.alertMessage = 'Are you sure to quit adding diagnosis ?';
			$scope.modalInstance = $modal({ scope: $scope, templateUrl: "app/src/views/templates/modal.file-upload-error.tpl.html", show: true, title: "Diagnosis not submitted yet" });
		};

	},
]);